import { useFeature } from '../../components/hooks/isFeatureEnabled';
import { PROJECT_HISTORY_IS_DISABLED } from '../../constants/features/constants';
import { canShowHistory } from '../project-model';

export const useProjectTimeline = (project) => {
    const historyIsDisabled = useFeature(PROJECT_HISTORY_IS_DISABLED);
    return canShowHistory(project) && !historyIsDisabled;
};
